// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { ChangePasswordModalComponent } from '../modals/change-password-modal/change-password-modal.component';
import { ChangePasswordComponent } from '../shared/password/password.component';
import { NewPasswordComponent } from '../login/new-password/new-password.component';

@Directive({
    selector: '[appValidatePassword]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PasswordValidatorDirective),
            multi: true,
        },
    ],
})
export class PasswordValidatorDirective implements Validator {
    // bring in the component we will need to use this directive on
    @Input() host!: ChangePasswordModalComponent | ChangePasswordComponent | NewPasswordComponent;

    validate(ctrl: AbstractControl): any {
        // has at least one lower case letter
        const lowercaseRegex = new RegExp('(?=.*[a-z])');
        //has at least one upper case letter
        const uppercaseRegex = new RegExp('(?=.*[A-Z])');
        // has at least one number
        const numRegex = new RegExp('(?=.*[0-9])');
        // contains these special characters
        const specialcharRegex = new RegExp('(?=.*[\\W])');

        const password = this.host.newPasswordForm.controls.password;

        const passwordValidators = {
            oldPassword: !!this.host.newPasswordForm.controls.currentPassword?.value?.length,
            hasLower: lowercaseRegex.test(password.value) ? true : false,
            hasUpper: uppercaseRegex.test(password.value) ? true : false,
            hasNumber: numRegex.test(password.value) ? true : false,
            hasSpecialChar: specialcharRegex.test(password.value) ? true : false,
            hasMinLength: password.value.length >= 8 ? true : false,
            bothMatch: this.checkPasswords(password.value, this.host.newPasswordForm.controls.password2?.value),
        };

        // set property on the host component that we use in the HTML
        this.host.passwordRequirements = passwordValidators;
    }

    // compare passwords for bothMatch property
    checkPasswords(password, password2): boolean {
        return password === '' && password2 === '' ? false : password === password2 ? true : false;
    }
}
